import React, { PureComponent } from 'react';
import Template from "../components/Template";
import Navbar from "../components/Navbar";
import axios from "axios";
import Config from "../components/axios/Config";
import Cookie from "js-cookie";
import ReactDatePicker from 'react-datepicker';
import { addOneDay, firstDayOfMonth, lastDayOfMonth } from '../components/helpers/Date';

const DateFormat = (datetime, forAPI) => {
    try {
        if (!datetime) return datetime;
        datetime = new Date(datetime);

        let MM = datetime.toLocaleString('default', { month: '2-digit' }); // long, short
        let MMM = datetime.toLocaleString('default', { month: 'short' }); // long, short
        let dd = datetime.toLocaleString('default', { day: '2-digit' });
        let yyyy = datetime.getFullYear();

        if (forAPI) return `${yyyy}-${MM}-${dd}`;
        else return `${dd} ${MMM} ${yyyy}`
    } catch (err) {
        return datetime;
    }
}

class Dashboard extends PureComponent {
    constructor(props) {
        super(props);

        let firstDay = firstDayOfMonth();
        let lastDay = lastDayOfMonth();

        this.state = {
            isLoading: true,
            goatTotal: 0,
            goatStocks: [],
            goatPens: [],
            goatBirths: [],
            goatSicks: [],
            goatDeaths: [],
            goatSolds: [],
            goatMatings: [],

            start_date: firstDay,
            end_date: lastDay,
        };
    }

    componentDidMount() {
        this.getDashboard();
        this.getDashboard2();
        this.getDashboard3();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.start_date !== this.state.start_date || prevState.end_date !== this.state.end_date) {
            this.getDashboard2();
            this.getDashboard3();
        }
    }

    unshiftTotalTab = (tempData, colorStyle) => {
        let total = 0;
        if (tempData.length > 0) {
            for (const item of tempData) {
                total += item.total
                item.colorStyle = colorStyle
            }

            tempData.unshift({
                colorStyle: "color-374650",
                total: total,
                goat_type_id: 0,
                goat_type_name: "TOTAL"
            })
        }
    }

    getDashboard = () => {
        axios.get(`${process.env.REACT_APP_BASE_API_URL}dashboard`, Config({
            Authorization: `Bearer ${Cookie.get('token')}`
        })).then(response => {
            if (response.data.success) {
                // ====================================== set state ======================================
                this.setState({
                    goatPens: response.data.data.goatPens,
                    isLoading: false,
                });
            }
        }).catch(error => {
            console.log(error)
        });
    }

    getDashboard2 = () => {
        let params = {
            start_date: DateFormat(this.state.start_date, true),
            end_date: DateFormat(this.state.end_date, true),
        }

        axios.get(`${process.env.REACT_APP_BASE_API_URL}dashboard2`, Config({
            Authorization: `Bearer ${Cookie.get('token')}`
        }, params)).then(response => {
            if (response.data.success) {
                // ====================================== count totals ======================================
                this.unshiftTotalTab(response.data.data.goatStocks, "color-00896A")
                this.unshiftTotalTab(response.data.data.goatBirths, "color-24ABE1")
                this.unshiftTotalTab(response.data.data.goatDeaths, "color-EB2424")
                this.unshiftTotalTab(response.data.data.goatSolds, "color-0C9344")

                // ====================================== set state ======================================
                this.setState({
                    goatTotal: response.data.data.goatStocks.find(x => x.goat_type_id === 0)?.total || 0,
                    goatStocks: response.data.data.goatStocks,
                    goatBirths: response.data.data.goatBirths,
                    goatDeaths: response.data.data.goatDeaths,
                    goatSolds: response.data.data.goatSolds,
                    goatMatings: response.data.data.goatMatings,
                });
            }
        }).catch(error => {
            console.log(error)
        });
    }

    getDashboard3 = () => {
        let params = {
            start_date: this.state.start_date,
            end_date: addOneDay(this.state.end_date),
        }

        axios.get(`${process.env.REACT_APP_BASE_API_URL}dashboard3`, Config({
            Authorization: `Bearer ${Cookie.get('token')}`
        }, params)).then(response => {
            if (response.data.success) {
                // ====================================== count totals ======================================
                this.unshiftTotalTab(response.data.data.goatSicks, "color-a49368")

                // ====================================== set state ======================================
                this.setState({
                    goatSicks: response.data.data.goatSicks,
                });
            }
        }).catch(error => {
            console.log(error)
        });
    }

    matingStatusLabel = {
        "created": "Persiapan",
        "mated": "Proses Perkawinan",
        "pregnant": "Bunting",
        "failed-pregnant": "Gagal Bunting",
        "laktasi": "Laktasi",
        "completed": "Selesai",
        "miscarriage": "Keguguran",
        "cancel": "Batal Perkawinan",
    }

    GoatTypeGrouping = (data) => {
        if (data.length > 0) return (
            <div className="" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, 410px)', gap: 10 }}>
                {data.map((item) => (
                    <div key={item.goat_type_id} className={`rounded bg-white shadow-graph py-4 px-3 text-center d-flex justify-content-between align-items-center`}>
                        <div className={`${item.colorStyle || "color-0F74BD"}`}>{item.goat_type_name}</div>
                        <h3 className="m-0 font-weight-bold">{item.total}</h3>
                    </div>
                ))}
            </div>

        )
        else return (
            <div>-</div>
        )
    }

    render() {
        return (
            <Template isLoading={this.state.isLoading}>
                <Navbar>
                    <h4 className="m-0 color-374650 font-weight-bold">Dashboard</h4>
                </Navbar>
                <div className="p-3 mb-5">
                    <p className="m-0 color-374650 font-weight-semi-bold">At your glance</p>

                    <div className="mt-4">
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, 410px)', gap: 10 }}>
                            <div>
                                <h6>Start Date</h6>
                                <ReactDatePicker wrapperClassName='form-control' className="form-control" selected={this.state.start_date}
                                    onChange={v => this.setState({ start_date: v })}
                                    dateFormat="dd MMM yyyy" showMonthDropdown showYearDropdown dropdownMode="select"
                                />
                            </div>
                            <div>
                                <h6>End Date</h6>
                                <ReactDatePicker wrapperClassName='form-control' className="form-control" selected={this.state.end_date}
                                    onChange={v => this.setState({ end_date: v })}
                                    dateFormat="dd MMM yyyy" showMonthDropdown showYearDropdown dropdownMode="select"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mt-4">
                        <div style={{ width: 620 }}>
                            <div className="rounded bg-white shadow-graph py-4 px-3 d-flex justify-content-between align-items-center">
                                <h5 className="font-weight-bold m-0">Total Semua Kambing Hidup</h5>
                                <h2 className="m-0 font-weight-bold">{this.state.goatTotal}</h2>
                            </div>
                        </div>
                    </div>

                    <div className="mt-4">
                        <h5 className="font-weight-bold">Total Kambing {DateFormat(this.state.start_date, false)} - {DateFormat(this.state.end_date, false)}</h5>
                        {this.GoatTypeGrouping(this.state.goatStocks)}
                    </div>

                    <div className="mt-4">
                        <h5 className="font-weight-bold">Kandang Gombekk</h5>
                        <div className="" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, 200px)', gap: 10 }}>
                            {this.state.goatPens.map((item) => (
                                <div key={item.id} className={`rounded bg-white shadow-graph py-5 px-3 text-center `}>
                                    <h2 className="font-weight-bold">{item.total_goats}</h2>
                                    <div className={`mt-3 color-a49368`}>{item.name}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="mt-4">
                        <h5 className="font-weight-bold">Total Perkawinan {DateFormat(this.state.start_date, false)} - {DateFormat(this.state.end_date, false)}</h5>
                        {this.state.goatMatings.length > 0 ?
                            <div className="" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, 200px)', gap: 10 }}>
                                {this.state.goatMatings.map((item) => (
                                    <div key={item.type} className={`rounded bg-white shadow-graph py-5 px-3 text-center`}>
                                        <h2 className="font-weight-bold">{item.total}</h2>
                                        <div className="mt-3 color-8CC73F">{this.matingStatusLabel[item.type]}</div>
                                    </div>
                                ))}
                            </div>
                            : <div>-</div>}
                    </div>

                    <div className="mt-4">
                        <h5 className="font-weight-bold">Kelahiran Kambing {DateFormat(this.state.start_date, false)} - {DateFormat(this.state.end_date, false)}</h5>
                        {this.GoatTypeGrouping(this.state.goatBirths)}
                    </div>

                    <div className="mt-4">
                        <h5 className="font-weight-bold">Penjualan Kambing {DateFormat(this.state.start_date, false)} - {DateFormat(this.state.end_date, false)}</h5>
                        {this.GoatTypeGrouping(this.state.goatSolds)}
                    </div>

                    <div className="mt-4">
                        <h5 className="font-weight-bold">Kambing Sakit {DateFormat(this.state.start_date, false)} - {DateFormat(this.state.end_date, false)}</h5>
                        {this.GoatTypeGrouping(this.state.goatSicks)}
                    </div>

                    <div className="mt-4">
                        <h5 className="font-weight-bold">Kematian Kambing {DateFormat(this.state.start_date, false)} - {DateFormat(this.state.end_date, false)}</h5>
                        {this.GoatTypeGrouping(this.state.goatDeaths)}
                    </div>

                    {/* <div className="mt-4">
                        <h5 className="font-weight-bold">Rincian Kambing</h5>
                        <div className="mt-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, 200px)', gap: 10 }}>
                            {this.state.goatHealths.map((item) => (
                                <div key={item.label} className={`rounded bg-white shadow-graph py-5 px-3 text-center ${item.colorStyle}`}>
                                    <h2 className="font-weight-bold">{item.amount}</h2>
                                    <div className="mt-3">{item.label}</div>
                                </div>
                            ))}
                        </div>
                    </div> */}
                </div>
            </Template>
        );
    }
}

export default Dashboard;